import { Box } from "@mui/material";
import Marker from "../markers/Marker";

const SimulatorMarker = ({
	number,
}: {
	number: number;
}) => {
	return (
		<Marker color="#CA7659" content={<Box>{number}</Box>} />
	);
};

export default SimulatorMarker;
